import {UseMedia} from 'hooks/useMedia';
import {useState} from 'react';
import Container from 'react-bootstrap/Container';
import Footer from '../../components/Footer/footer.jsx';
// import './about.css';
import pattern from '../Home/pattern4.png';
import Markdown from 'markdown-to-jsx';

export default function Rules() {
  const [media, setMedia] = useState();
  UseMedia('min-width', 1000, setMedia);

  return (
    <div
      className="Whole_div rules"
      style={{backgroundImage: `url(${pattern})`}}
    >
      <Container fluid>
        <Markdown>{`
# Rules

## What you will develop 

A web site that falls into one of the following categories:

-   Culture, art, sport, recreation

-   Education and research

-   Tourism

-   E-health

-   Smart city

The theme will be randomly selected live, Saturday morning.

## The rules of the competition

1.  Teams must have a minimum of 2 members, but no more than 4 members. 

2.  Teams should be made up exclusively of second year "Web technologies" undergraduates who are not organisers, volunteers, judges, sponsors, or in any other privileged position at the event.

3.  The intro and the announcement of the winners will happen in person at the Faculty of Automatic Control and Computers, EC Hallway

4.  All team members should be present at the event. 

5.  Teams can, of course, gain advice and support from organisers, volunteers, sponsors, and others.

6.  No development may start before the actual date and time of the event. Any teams that violate this rule will be automatically disqualified.

7.  The project must respect the challenge.

8.  You should only use standard HTML, CSS and JavaScript. Teams cannot use libraries, frameworks, ChatGPT or open-source code in their projects.

9.  Working on a project before the event and open-sourcing it for the sole purpose of using the code during the event is against the spirit of the rules and is not allowed.

10. Participants must have an active GitHub account before the start of the event.

11. All the teams must have at least one commit with their work by Saturday, 14:00.

12. Teams must stop hacking at 15:30. After hacking finishes, teams must submit their projects and presentations to GitHub; a repo must have two components to be eligible for judging:
 
  - the project's code;

  - the project's presentation (power point, google slides).

14. After hacking finishes, teams will show their projects to each other and to the judges. Each team will be given 5 minutes to present their ideas. You are strongly allowed to present a demo of what you have built.

15. You are encouraged to present what you have done even if your hack is broken or you weren't able to finish. It's okay if you didn't finish your hack---that happens all the time! Demoing is not just about the competition. It's a chance to share with others what you learned and what you tried to build---that's what hacking's all about! In the case that you don't have anything to demo, you can give a presentation about what you tried and what you learned. Hearing what other people learned is interesting and inspiring for other attendees.

16. You are allowed to come with your own personal gear (laptop, monitor, headphones, extension cord, etc).

17. All project submissions will be code-reviewed. Applications will be spot checked by code reviewers, and mentors. All the projects selected by the judges as finalists will be code reviewed to confirm that the code is original work created at the hackathon and that all components and assets conform to the licences allowed in these rules.

18. After the hacking time ends, the jury will take some minutes to deliberate on the winners.

19. All the participants who will present their project will be given participation certificates. Winners will be given merit certificates.

## Judging Criteria

Teams will be judged on these 3 criteria. During judging, participants should try to describe what they did for each criterion in their project.

-   Technical Mastery (50%): Is the project technically complex? Does it seem remarkable that someone could achieve this hack in just less than 8 hours? Does it work well? Does it look and feel nice? 

-   UI / UX (30%): Is the project user-friendly or intuitive? How consistent is the design for the entire application? How impactful is it? How innovative is it? Is it relevant to the chosen theme?

-   How well you pitch (20%): How well did you convince the jury to use your application?

### Technical Mastery:

-   The html document should follow a semantic structure. See [web.dev](https://web.dev/learn/html/semantic-html/). 


- The website file structure should contain:

  - Assets (images, videos)
      
    - Should be in a separate folder.
      
    - Their file names need to clearly indicate what they are.
      
    - Consider if you want some assets to also be organized in folders depending on the page they are used in.
  
  - Styles (CSS files)
    
    - In a separate folder.
    
    - You will likely need a global css file that is used across all pages, and separate css files that are used only on a single page.
  
  - Scripts (JavaScript files)
    
    - In a separate folder.

- A navigation list (\`<nav>\`) shows links to all the pages to be included in the web site. Navigation allows the user to navigate between all pages.

- The criteria for the website header:
  
  - Header shows a site logo
  
  - Header shows a site title
  
  - Header shows a navigation that allows the user to move to other pages
  
  - The current page the user is on is highlighted in the navigation
  
  - On mobile devices, the navigation collapses and shows a smaller menu

  - The website should embed at least one video. It can either be a local video file or a video from a video hosting website.

- The website should embed a photo gallery.

### UI / UX

-   Did the team put thought into the user experience?

-   How well designed is the interface?

-   How is the CSS code written?

-   Is the website responsive?

-   Does the website look good on mobile devices?

### Pitching

-   Did you present as a team?

-   Was your presentation engaging?

# Happy Hacking :)`}</Markdown>
      </Container>
      <Footer />
    </div>
  );
}
